module.exports = __webpack_public_path__ + "038.7b655cf8.png";